/**
 * MasonryList 스타일
 * @description 앱은 셀마다 여백을 둘러 바깥 여백과 열 사이 간격을 같게 만든다(탭 8 · 그 밖 16).
 *   웹은 CSS grid 가 그 둘을 따로 갖는다 — 바깥은 `--fw-inset-*`, 열 사이는 같은 값의
 *   고정 갭(8/16), 줄 사이는 16 으로 두 경우가 같다.
 *
 *   열 수는 폭이 정한다. 시안은 폰 2열이고, 넓은 화면은 카드 폭이 시안(190)에서 멀어지지
 *   않는 만큼만 늘린다 — 태블릿 3열 · 데스크톱 4열.
 *
 *   ## 왜 grid 인가
 *   앱의 마손리는 높이가 제각각인 홈 피드 카드를 위한 것이다. Discovery 의 카드는 비율이
 *   같고 글자 자리를 못 박아(`fixedTextHeight`) 높이가 같으므로, 짧은 열에 넣는 배분과 grid 는
 *   같은 그림이 된다. 높이가 다른 카드가 오면 그때 열 배분을 클라이언트에서 계산한다.
 */
import { cva } from "class-variance-authority";

export const masonryListStyles = {
  root: "flex w-full flex-col",
  grid: cva(
    "grid grid-cols-2 gap-y-[var(--fw-space-gap-lg)] pt-[var(--fw-space-gap-lg)] tablet:grid-cols-3 desktop:grid-cols-4",
    {
      variants: {
        inset: {
          tab: "gap-x-[var(--fw-space-gap-sm)] px-[var(--fw-inset-tab)] tablet:gap-x-[var(--fw-space-gap-lg)]",
          screen: "gap-x-[var(--fw-space-gap-lg)] px-[var(--fw-inset-screen)]",
        },
      },
      defaultVariants: { inset: "screen" },
    },
  ),
  /** 카드는 셀 위에 붙는다 — 줄 안에서 높이가 다르면 위를 맞춘다 */
  cell: "min-w-0 self-start",
  footer: "flex w-full justify-center py-[var(--fw-space-inset-xl)]",
};
